import './JobDescription.scss';

import { Tab, Tabs, Typography } from '@mui/material';
import {
  CandidateSubmissionType,
  JobData,
  User,
} from 'components/JobQueue/utils';
import EmlViewerFromApi from 'pages/common/EmlViewer';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getAllListData } from 'services/CommonServices';
import { MASTER_ENDPOINT, SALES_ENDPOINT } from 'utils/Constant';

import CandidateCard from './CandidateCard';
import Header from './Header';

interface JobDescriptionProps {
  jobSummary: string;
  // keyResponsibilities: string[];
  // requiredSkills: string[];
  jobData: JobData;
  submittedRefreshSignal: number;
}

const JobDescription: React.FC<JobDescriptionProps> = ({
  jobData,
  jobSummary,
  submittedRefreshSignal,
}) => {
  const [users, setUsers] = useState<User[]>([]);
  const [emailData, setEmailData] = useState<string>('');
  const [activeTab, setActiveTab] = useState(0);
  const [submittedList, setSubmittedList] = useState<CandidateSubmissionType[]>(
    [],
  );
  const [submittedCount, setSubmittedCount] = useState(0);

  const location = useLocation();
  const Params = location?.state?.Params;
  const userData = () => {
    getAllListData(
      `${MASTER_ENDPOINT.Admins}?sortby=name&order=ASC&roleId=5&search=&skip=&take=&organizationId=&status=true`,
    )
      .then((res) => {
        setUsers(res?.data);
      })
      .catch((err) => {});
  };
  const submittedListedData = () => {
    getAllListData(
      `${SALES_ENDPOINT.MatchedCandidates}/${
        jobData?.id
      }?type=submitted&sourceQueue=${'benchQueue'}`,
    )
      .then((res) => {
        setSubmittedList(res?.data || []);
        setSubmittedCount(res?.data?.length || 0);
      })
      .catch((err) => {});
  };
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const handleBack = () => {
    // Navigate back to job queue
  };

  const handleCloseJob = () => {
    // Handle close job functionality
  };

  useEffect(() => {
    userData();
    submittedListedData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, submittedRefreshSignal]);

  const hasOriginalEmailTab = jobData?.jobSource === 'email';
  const submittedTabIndex = hasOriginalEmailTab ? 2 : 1;
  const isJobDescriptionTab = activeTab === 0;
  // const isOriginalEmailTab = hasOriginalEmailTab && activeTab === 1;
  const isSubmittedTab = activeTab === submittedTabIndex;

  return (
    <div
      style={{
        backgroundColor: '#FFFFFF',
        height: '100%',
      }}>
      {/* Header */}
      <Header
        jobTitle={jobData?.jobTitle || ''}
        company={jobData?.customer?.name || ''}
        location={`${jobData?.city || ''}${
          jobData?.city?.length > 0 ? ', ' : ''
        }${jobData?.state ? ` ${jobData?.state}` : ''}`}
        timePosted={jobData?.createdAt || ''}
        billRate={((): string => {
          const from = Number(jobData?.payRangeFrom);
          const to = Number(jobData?.payRangeTo);
          if (from > 0 && to > 0) {
            return `$${from} - $${to}`;
          } else if (from > 0) {
            return `$${from}`;
          } else if (to > 0) {
            return `$${to}`;
          } else {
            return '-';
          }
        })()}
        source={jobData?.jobSource || ''}
        assignedUsers={jobData?.usersAssigned || []}
        onBack={handleBack}
        onCloseJob={handleCloseJob}
        users={users}
        jobId={jobData?.id || ''}
        jobData={jobData}
        Params={Params}
        sourceLink={jobData?.jobSourceUrl || ''}
        isJobClose={jobData?.isClosed || false}
        statusReason={jobData?.statusReason || ''}
      />
      {/* Tabs */}
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{
          '& .Mui-selected': {
            color: '#000000 !important',
          },
          '& .MuiTab-root': {
            color: '#000000',
            fontFamily: 'Inter',
            fontSize: '14px',
            padding: '12px 4px',
            textTransform: 'none',
          },
          '& .MuiTabs-flexContainer': {
            gap: '12px',
          },
          '& .MuiTabs-indicator': {
            backgroundColor: '#be0000',
            height: '2px',
          },
        }}>
        <Tab
          sx={{
            '&.Mui-selected': {
              color: '#000000 !important',
            },
            fontWeight: activeTab === 0 ? 500 : 400,
            lineHeight: 'normal',
            opacity: activeTab === 0 ? 1 : 0.6,
          }}
          label="Job Description"
        />
        {jobData?.jobSource === 'email' && (
          <Tab
            sx={{
              '&.Mui-selected': {
                color: '#000000 !important',
              },
              fontWeight: activeTab === 1 ? 500 : 400,
              lineHeight: 'normal',
              opacity: activeTab === 1 ? 1 : 0.6,
            }}
            label="Original Email"
          />
        )}
        <Tab
          sx={{
            '&.Mui-selected': {
              color: '#000000 !important',
            },

            fontWeight: activeTab === 2 ? 500 : 400,
            lineHeight: 'normal',
            opacity: activeTab === 2 ? 1 : 0.6,
          }}
          label={`Submitted to Client (${submittedCount})`}
        />
      </Tabs>

      {/* Content */}
      {isJobDescriptionTab && (
        <div
          style={{
            gap: '10px',
            maxHeight: 'calc(100vh - 250px)',
            overflow: 'auto',
            padding: '16px 24px',
          }}>
          {/* Job Summary */}
          <div
            style={{ border: 'unset', marginBottom: '8px', padding: '0px' }}
            className="contain-box">
            {(() => {
              // Check if content contains HTML tags
              const hasHtmlTags =
                jobSummary && /<[a-z][\s\S]*>/i.test(jobSummary);

              // If HTML, use dangerouslySetInnerHTML
              if (hasHtmlTags) {
                return (
                  <Typography
                    component={'div'}
                    className="contain-info wrapper-info"
                    sx={{
                      color: '#616161',
                      fontFamily: 'Inter',
                      fontSize: '12px',
                      fontWeight: 400,
                      lineHeight: '22px',
                      paddingBottom: '8px',
                      paddingLeft: '0px',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: jobSummary || '-',
                    }}
                  />
                );
              }

              // If plain text, render with line breaks preserved
              return (
                <Typography
                  component={'div'}
                  className="contain-info wrapper-info"
                  sx={{
                    color: '#616161',
                    fontFamily: 'Inter',
                    fontSize: '12px',
                    fontWeight: 400,
                    lineHeight: '22px',
                    paddingBottom: '8px',
                    paddingLeft: '0px',
                    whiteSpace: 'pre-wrap',
                  }}>
                  {jobSummary?.replace(/\n/g, '\n') || '-'}
                </Typography>
              );
            })()}
          </div>

          {/* Information Cards */}
          <div
            style={{
              display: 'flex',
              gap: '16px',
              marginBottom: '24px',
            }}>
            {/* Pay Rate Card */}
            <div
              style={{
                background: 'rgba(253, 255, 249, 1)',
                backgroundColor: '#ffffff',
                borderBottom: '4px solid #40af7b',
                borderRadius: '8px',
                boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.08)',
                flex: 1,
                padding: '16px',
                textAlign: 'center',
              }}>
              <Typography
                sx={{
                  color: '#111827',
                  fontFamily: 'Red Hat Display Medium',
                  fontSize: '14px',
                  fontWeight: 500,
                  marginBottom: '4px',
                }}>
                {((): string => {
                  const from = Number(jobData?.payRangeFrom);
                  const to = Number(jobData?.payRangeTo);
                  if (from > 0 && to > 0) {
                    return `$${from} - $${to}`;
                  } else if (from > 0) {
                    return `$${from}`;
                  } else if (to > 0) {
                    return `$${to}`;
                  } else {
                    return '-';
                  }
                })()}
              </Typography>
              <Typography
                sx={{
                  color: '#10b981',
                  fontFamily: 'Inter',
                  fontSize: '12px',
                  fontWeight: 400,
                  lineHeight: '22px',
                }}>
                Pay Rate
              </Typography>
            </div>

            {/* Project Start Date Card */}
            <div
              style={{
                background: '#F8FCFF',
                backgroundColor: '#F8FCFF',
                borderBottom: '4px solid #2f8bbf',
                borderRadius: '8px',
                boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.08)',
                flex: 1,
                padding: '16px',
                textAlign: 'center',
              }}>
              <Typography
                sx={{
                  color: '#111827',
                  fontFamily: 'Red Hat Display Medium',
                  fontSize: '14px',
                  fontWeight: 500,
                  marginBottom: '4px',
                }}>
                {jobData?.startDate
                  ? new Date(jobData.startDate).toLocaleDateString()
                  : '-'}
              </Typography>
              <Typography
                sx={{
                  color: '#3b82f6',
                  fontFamily: 'Inter',
                  fontSize: '12px',
                  fontWeight: 400,
                  lineHeight: '22px',
                }}>
                Project Start Date
              </Typography>
            </div>

            {/* Position Type Card */}
            <div
              style={{
                background: '#FCF9FF',
                backgroundColor: '#FCF9FF',
                borderBottom: '4px solid #943EDA',
                borderRadius: '8px',
                boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.08)',
                flex: 1,
                padding: '16px',
                textAlign: 'center',
              }}>
              <Typography
                sx={{
                  color: '#111827',
                  fontFamily: 'Red Hat Display Medium',
                  fontSize: '14px',
                  fontWeight: 500,
                  marginBottom: '4px',
                }}>
                {jobData?.positionType || '-'}
              </Typography>
              <Typography
                sx={{
                  color: '#a855f7',
                  fontFamily: 'Inter',
                  fontSize: '12px',
                  fontWeight: 400,
                  lineHeight: '22px',
                }}>
                Position Type
              </Typography>
            </div>
          </div>

          {/* Job Details List */}
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '8px',
              padding: '16px',
            }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
              }}>
              {/* Education */}
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                }}>
                <Typography
                  sx={{
                    color: '#616161',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '20px',
                    minWidth: '250px',
                  }}>
                  Education
                </Typography>
                <Typography
                  sx={{
                    color: '#6b7280',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: '20px',
                  }}>
                  {jobData?.education || '-'}
                </Typography>
              </div>

              {/* Interview Type */}
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                }}>
                <Typography
                  sx={{
                    color: '#616161',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '20px',
                    minWidth: '250px',
                  }}>
                  Interview Type
                </Typography>
                <Typography
                  sx={{
                    color: '#6b7280',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: '20px',
                  }}>
                  {jobData?.interviewType || '-'}
                </Typography>
              </div>

              {/* Duration */}
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                }}>
                <Typography
                  sx={{
                    color: '#616161',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '20px',
                    minWidth: '250px',
                  }}>
                  Duration
                </Typography>
                <Typography
                  sx={{
                    color: '#6b7280',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: '20px',
                  }}>
                  {jobData?.jobDurationTo ? jobData?.jobDurationTo : '-'}
                  {jobData?.jobDurationTo && jobData?.jobDurationTo === 24
                    ? '+'
                    : ''}
                  {jobData?.jobDurationTo && ' Months'}
                </Typography>
              </div>

              {/* Experience */}
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                }}>
                <Typography
                  sx={{
                    color: '#616161',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '20px',
                    minWidth: '250px',
                  }}>
                  Experience
                </Typography>
                <Typography
                  sx={{
                    color: '#6b7280',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: '20px',
                  }}>
                  {(() => {
                    const from = Number(jobData?.expFrom);
                    const to = Number(jobData?.expTo);
                    if (from > 0 && to > 0) {
                      return `${from} - ${to}`;
                    } else if (from > 0) {
                      return `${from}`;
                    } else if (to > 0) {
                      return `${to}`;
                    } else {
                      return '-';
                    }
                  })()}
                </Typography>
              </div>
              {/* Location */}
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                }}>
                <Typography
                  sx={{
                    color: '#616161',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '20px',
                    minWidth: '250px',
                  }}>
                  Location
                </Typography>
                <Typography
                  sx={{
                    color: '#6b7280',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: '20px',
                    textTransform: 'capitalize',
                  }}>
                  {(() => {
                    const city = jobData?.city?.trim();
                    const state = jobData?.state?.trim();
                    if (city && state) {
                      return `${city}, ${state}`?.toLocaleLowerCase();
                    } else if (city) {
                      return city?.toLocaleLowerCase();
                    } else if (state) {
                      return state?.toLocaleLowerCase();
                    } else {
                      return '-';
                    }
                  })()}
                </Typography>
              </div>

              {/* Work Status */}
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                }}>
                <Typography
                  sx={{
                    color: '#616161',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '20px',
                    minWidth: '250px',
                  }}>
                  Work Status
                </Typography>
                <Typography
                  sx={{
                    color: '#6b7280',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: '20px',
                  }}>
                  {jobData?.jobWorkStatus
                    ?.map((ws) => ws?.workStatus?.name)
                    ?.filter(Boolean)
                    .join(', ')
                    .trim() || '-'}
                </Typography>
              </div>

              {/* Certifications */}
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                }}>
                <Typography
                  sx={{
                    color: '#616161',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '20px',
                    minWidth: '250px',
                  }}>
                  Certifications
                </Typography>
                <Typography
                  sx={{
                    color: '#6b7280',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: '20px',
                  }}>
                  {jobData?.certificates || '-'}
                </Typography>
              </div>

              {/* Sales Person */}
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                }}>
                <Typography
                  sx={{
                    color: '#616161',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '20px',
                    minWidth: '250px',
                  }}>
                  Sales Person
                </Typography>
                <Typography
                  sx={{
                    color: '#6b7280',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: '20px',
                  }}>
                  {jobData?.user
                    ? `${jobData?.user?.firstName} ${jobData?.user?.lastName}`
                    : '-'}
                </Typography>
              </div>

              {/* Expected Resume Score */}
              <div
                style={{
                  alignItems: 'center',
                  display: 'flex',
                }}>
                <Typography
                  sx={{
                    color: '#616161',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '20px',
                    minWidth: '250px',
                  }}>
                  Expected Resume Score
                </Typography>
                <Typography
                  sx={{
                    color: '#6b7280',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: '20px',
                  }}>
                  {jobData?.expectedResumeScore || '-'}
                </Typography>
              </div>

              <Typography component={'div'} className="exp-tables">
                <table>
                  <thead>
                    <tr>
                      <th
                        className="w-50"
                        style={{
                          paddingLeft: '4px',
                        }}>
                        Skills
                      </th>
                      <th className="w-25"># Yrs Required</th>
                      <th className="w-23">Preferred</th>
                    </tr>
                  </thead>
                  <tbody>
                    {jobData?.jobSkills &&
                      jobData?.jobSkills.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td
                              className="w-50"
                              style={{
                                paddingLeft: '4px',
                              }}>
                              {item?.skill?.name}
                            </td>
                            <td
                              className="w-25"
                              style={{
                                textAlign: 'left',
                              }}>
                              {item?.required}
                            </td>
                            <td
                              className="w-23"
                              style={{
                                textAlign: 'left',
                              }}>
                              {item?.preffered}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </Typography>
            </div>
          </div>
        </div>
      )}

      {jobData?.jobSource === 'email' && activeTab === 1 && (
        <div
          style={{
            maxHeight: 'calc(100vh - 250px)',
            overflow: emailData ? 'auto' : 'hidden',
          }}>
          <Typography component={'div'} sx={{ whiteSpace: 'pre-wrap' }}>
            <EmlViewerFromApi
              jobId={jobData?.id}
              setEmailDataContent={setEmailData}
              source={jobData?.jobSource}
            />
          </Typography>
        </div>
      )}

      {isSubmittedTab && (
        <div
          style={{
            background: '#ffffff',
            maxHeight: 'calc(100vh - 250px)',
            overflowY: 'auto',
            padding: '16px 24px 24px',
          }}>
          {submittedList?.length ? (
            submittedList.map((candidate) => {
              const candidateDetails = candidate?.candidate;
              const candidateName = `${candidateDetails?.firstName || ''} ${
                candidateDetails?.middleName?.trim() || ''
              } ${candidateDetails?.lastName?.trim() || ''}`
                .replace(/\s+/g, ' ')
                .trim();
              const location = `${candidateDetails?.city?.trim() || ''}, ${
                candidateDetails?.state?.trim() || ''
              }`
                .replace(/^[,\s]+|[,\s]+$/g, '')
                .trim();

              return (
                <div key={candidate?.id} style={{ marginBottom: '12px' }}>
                  <CandidateCard
                    jobId={jobData?.id || ''}
                    candidate={candidate}
                    matchPercentage={candidate?.matchPercentage}
                    visaStatus={candidateDetails?.workStatus?.name}
                    source={candidateDetails?.source}
                    name={candidateName || '-'}
                    availability={candidateDetails?.benchStatus}
                    availabilityDate={candidateDetails?.benchAvailability}
                    email={candidateDetails?.email}
                    phone={
                      candidateDetails?.phone || candidateDetails?.mobileNumber
                    }
                    location={location || '-'}
                    isSelected={false}
                    topSkills={(candidate as any)?.topSkills
                      ?.map((skill) => skill)
                      .filter(Boolean)
                      .join(', ')}
                    onSelect={() => {}}
                    isShortList={true}
                    submittedOn={candidate?.submittedAt}
                    submittedBy={
                      candidate?.submittedUser
                        ? `${candidate?.submittedUser?.firstName || ''} ${
                            candidate?.submittedUser?.lastName || ''
                          }`.trim()
                        : ''
                    }
                    activeTab={-1}
                  />
                </div>
              );
            })
          ) : (
            <div
              style={{
                alignItems: 'center',
                color: '#6b7280',
                display: 'flex',
                fontFamily: 'Red Hat Display Medium',
                fontSize: '14px',
                height: '100%',
                justifyContent: 'center',
                minHeight: '160px',
                textAlign: 'center',
              }}>
              No candidates submitted to the client yet.
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default JobDescription;
